import { LocalDate, LocalDateTime, LocalTime, YearMonth, ZonedDateTime, ZoneId, ZoneOffset } from '@js-joda/core';
import { localDateSerializer } from './LocalDateSerializer';
import { localDateTimeSerializer } from './LocalDateTimeSerializer';
import { localTimeSerializer } from './LocalTimeSerializer';
import { serializerRegistrations } from './serializerRegistrations';
import { yearMonthSerializer } from './YearMonthSerializer';
import { zonedDateTimeSerializer } from './ZonedDateTimeSerializer';
import { zoneIdSerializer } from './ZoneIdSerializer';
import { zoneOffsetSerializer } from './ZoneOffsetSerializer';
let isRegistered = false;
export function registerJodaSerializers() {
    if (isRegistered) {
        return;
    }
    serializerRegistrations.push({ type: YearMonth, serializer: yearMonthSerializer }, { type: LocalDate, serializer: localDateSerializer }, { type: LocalTime, serializer: localTimeSerializer }, { type: LocalDateTime, serializer: localDateTimeSerializer }, { type: ZonedDateTime, serializer: zonedDateTimeSerializer }, { type: ZoneId, serializer: zoneIdSerializer }, { type: ZoneOffset, serializer: zoneOffsetSerializer });
    isRegistered = true;
}
